import React from "react";

import PropTypes from "prop-types";

import Tooltip from "shared/components/Tooltip";
import { ShieldIcon } from "shared/components/vega/icons";

import {
  getSentilinkApplicantChipLabel,
  getSentilinkApplicantTooltip,
  isSentilinkLabeledChipTier,
  SENTILINK_RISK_STATUS,
} from "../sentilinkRiskStatus";

import {
  SentilinkApplicantChipContainer,
  SentilinkApplicantChipLabel,
  SentilinkApplicantShieldIcon,
} from "./styled";

const getShieldVariant = (tier) => {
  switch (tier) {
    case SENTILINK_RISK_STATUS.HIGH_RISK:
      return "highRisk";
    case SENTILINK_RISK_STATUS.ERROR:
      return "error";
    case SENTILINK_RISK_STATUS.NEEDS_REVIEW:
      return "needsReview";
    case SENTILINK_RISK_STATUS.LOW_RISK:
      return "lowRiskMuted";
    case SENTILINK_RISK_STATUS.CHECKING:
      return "checking";
    default:
      return "neutral";
  }
};

const SentilinkApplicantChip = ({ tier }) => {
  if (!tier || tier === SENTILINK_RISK_STATUS.NOT_STARTED) {
    return null;
  }

  if (tier === SENTILINK_RISK_STATUS.SKIPPED_NO_SSN) {
    return null;
  }

  if (tier === SENTILINK_RISK_STATUS.NOT_APPLICABLE) {
    return null;
  }

  const variant = getShieldVariant(tier);
  const tooltip = getSentilinkApplicantTooltip(tier);
  const showLabel = isSentilinkLabeledChipTier(tier);

  return (
    <Tooltip title={tooltip} placement="top">
      <SentilinkApplicantChipContainer
        data-testid="sentilink-applicant-chip"
        data-tier={tier}
      >
        <SentilinkApplicantShieldIcon variant={variant} aria-hidden="true">
          <ShieldIcon />
        </SentilinkApplicantShieldIcon>
        {showLabel && (
          <SentilinkApplicantChipLabel variant={variant}>
            {getSentilinkApplicantChipLabel(tier)}
          </SentilinkApplicantChipLabel>
        )}
      </SentilinkApplicantChipContainer>
    </Tooltip>
  );
};

SentilinkApplicantChip.propTypes = {
  tier: PropTypes.string,
};

SentilinkApplicantChip.defaultProps = {
  tier: null,
};

export default SentilinkApplicantChip;
